import { Sparkles } from "lucide-react";
import { useLang } from "../LanguageContext";

export const Marquee = () => {
  const { s } = useLang();
  const Row = ({ hidden = false }) => (
    <div className="flex shrink-0 items-center" aria-hidden={hidden}>
      {s.marquee.map((item, i) => (
        <span
          key={i}
          className="flex items-center gap-8 pr-8 font-mono text-[11px] uppercase tracking-[0.34em] text-white/45 sm:text-xs"
        >
          {item}
          <Sparkles className="h-3.5 w-3.5 text-gold/70" />
        </span>
      ))}
    </div>
  );

  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-white/[0.07] bg-white/[0.015] py-5"
    >
      <div className="flex w-max animate-marquee">
        <Row />
        <Row hidden />
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-obsidian to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-obsidian to-transparent" />
    </div>
  );
};
